import L from 'leaflet';

const TILE_URL = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';
const TILE_ATTR = '&copy; <a href="https://openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/attributions">CARTO</a>';

export function initMap(el) {
  const map = L.map(el, { preferCanvas: true }).setView([48.5, 10.5], 5);
  L.tileLayer(TILE_URL, { attribution: TILE_ATTR, subdomains: 'abcd', maxZoom: 19 }).addTo(map);

  const layers = {
    includes: L.layerGroup().addTo(map),
    excludes: L.layerGroup().addTo(map),
    postcodes: L.layerGroup().addTo(map),
    markers: L.layerGroup().addTo(map)
  };

  return { map, layers };
}

export function drawAreas({ map, layers }, includes, excludes) {
  layers.includes.clearLayers();
  layers.excludes.clearLayers();

  for (const f of includes) {
    if (!f) continue;
    L.geoJSON(f, {
      style: { color: '#3563ff', weight: 2, fillColor: '#3563ff', fillOpacity: 0.12 }
    }).addTo(layers.includes);
  }
  for (const f of excludes) {
    if (!f) continue;
    L.geoJSON(f, {
      style: { color: '#e23a5e', weight: 2, fillColor: '#e23a5e', fillOpacity: 0.18, dashArray: '4,3' }
    }).addTo(layers.excludes);
  }
}

export function drawMarkers({ layers }, points) {
  layers.markers.clearLayers();
  for (const p of points) {
    if (p.lat == null || p.lon == null) continue;
    const color = p.kind === 'exclude' ? '#e23a5e' : '#3563ff';
    L.circleMarker([p.lat, p.lon], {
      radius: 6,
      color: '#fff',
      weight: 2,
      fillColor: color,
      fillOpacity: 1
    })
      .bindTooltip(p.label || '(point)', { direction: 'top', offset: [0, -4] })
      .addTo(layers.markers);
  }
}

export function drawPostcodes({ layers }, features) {
  layers.postcodes.clearLayers();
  if (!features.length) return;
  L.geoJSON(
    { type: 'FeatureCollection', features },
    {
      style: { color: '#16a34a', weight: 0.7, fillColor: '#16a34a', fillOpacity: 0.30 },
      onEachFeature: (f, layer) => {
        const p = f.properties || {};
        layer.bindTooltip(`${p.country || ''} ${p.plz || ''}`.trim(), { sticky: true });
      }
    }
  ).addTo(layers.postcodes);
}

export function fitToBounds({ map }, bboxArr) {
  if (!bboxArr || bboxArr.length !== 4) return;
  const [minX, minY, maxX, maxY] = bboxArr;
  map.fitBounds([[minY, minX], [maxY, maxX]], { padding: [24, 24] });
}
